import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { SharedComponents } from '../../../components/shared.module';
import { ProjectService } from '../../../core/services/project/project.service';
import { RestService } from '../../../core/services/rest.service';
import { ToasterService } from '../../../core/services/toaster-service';
import { MaterialModule } from '../../../core/shared/material.module';
import { testScheduleColumns } from '../../../core/table-templates/schedule-table';
import { MessageEnum } from '../../../core/utils/message.enum';
import { AddScheduleComponent } from '../add-schedule/add-schedule.component';
import { CronExpressionInputComponent } from '../cron-expression-input/cron-expression-input.component';
import { TestScheduleRelaseComponent } from '../test-schedule-relase/test-schedule-relase.component';

@Component({
  selector: 'app-test-schedule',
  standalone: true,
  imports: [FormsModule, MaterialModule, SharedComponents, CommonModule, MatIconModule],
  templateUrl: './test-schedule.component.html',
  styleUrl: './test-schedule.component.scss'
})
export class TestScheduleComponent implements OnInit {

  searchText: string = '';
  isSelfHealingUp: boolean = false;
  isAnalysUp: boolean = false;
  private modalService = inject(NgbModal);
  isSchedulesLoaded = false;
  isSchedulesByIdloaded = true;
  projectId: any = '';
  automationProjectId: any = '';
  private messageService = inject(MessageService);
  columns: any = testScheduleColumns;
  tableOptions: any = {
    expandable: true
  }
  schedules: any[] = [];
  dataSource: any[] = [];
  activeSchedule: any = null;

  cronExpression: string = '';
  errorMessage: string | null = null;
  enableEdit = false;

  constructor(
    private restService: RestService,
    private projectService: ProjectService,
    private readonly toaster: ToasterService
  ) {
    this.projectService.getProjectId().subscribe((id) => {
      this.projectId = id;
    });
    this.projectService.getAutomationProjectId().subscribe((id: any) => {
      this.automationProjectId = id;
    });
  }

  ngOnInit(): void {
    this.getAllSchedules();
  }

  getAllSchedules() {
    this.restService.getAllSchedules(this.projectId, this.automationProjectId).subscribe((response) => {
      let data = response.data;
      this.schedules = [];
      data.forEach((schedule: any) => {
        this.schedules.push({
          id: schedule.id,
          name: schedule.name,
          enabled: schedule.enabled,
          checked: false,
          plans: schedule.plans,
          cron: schedule?.cron ? schedule?.cron : "",
        });
      });
      this.isSchedulesLoaded = true;
    }, (error) => {
      this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_LOAD_FAILURE });
      this.isSchedulesLoaded = true;
    });
  }

  modifyCaseTree() {

  }

  updateSchecules(event: any, schedule: any, field: string) {
    event.stopPropagation();
    let index = this.schedules.findIndex(((sch: any) => sch.id === schedule.id));
    let updatedSchedule = { ...schedule };
    if (field === 'enabled') {
      this.restService.enableDisableSchedule(this.projectId, this.automationProjectId, updatedSchedule.id, !updatedSchedule[field]).subscribe((response) => {
        updatedSchedule[field] = !updatedSchedule[field];
        this.schedules.splice(index, 1, updatedSchedule);
        this.toaster.pop({ type: 'success', text: MessageEnum.SCHEDULE_UPDATE_SUCCESS });
      }, (error) => {
        this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_UPDATE_FAILURE });
      });
    } else {
      updatedSchedule[field] = !updatedSchedule[field];
      this.schedules.splice(index, 1, updatedSchedule);
    }
  }

  addOrRemoveTestSchedule(type: string) {
    if (type == "+") {
      const modalRef = this.modalService.open(AddScheduleComponent, {
        centered: false,
        windowClass: "test-plan-modal",
        backdrop: 'static',
      });
      modalRef.componentInstance.data = {
        title: "Add New Test Schedule"
      };
      modalRef.result.then((result) => {
        this.isSchedulesLoaded = false;
        this.getAllSchedules();
      });
    } else {
      let selectedIds: any = [];
      this.schedules.forEach((sch: any) => {
        if (sch.checked) {
          selectedIds.push(sch.id)
        }
      })
      if (selectedIds.length) {
        this.restService.deleteSchedule(this.projectId, this.automationProjectId, selectedIds).subscribe((response) => {
          this.activeSchedule = null;
          this.cronExpression = "";
          this.getAllSchedules();
          this.toaster.pop({ type: 'success', text: MessageEnum.SCHEDULE_DELETE_SUCCESS });
        }, (error) => {
          this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_DELETE_FAILURE });
        });
      }
    }
  }

  buildDataSourceFromObject(schedule: any) {
    if (this.activeSchedule?.id === schedule.id) {
      return;
    }
    this.activeSchedule = schedule;
    this.cronExpression = this.activeSchedule?.cron;
    this.dataSource = [];
    this.isSchedulesByIdloaded = false;
    this.restService.getPlansByScheduleId(this.projectId, this.automationProjectId, schedule.id).subscribe((response) => {
      let data = response.data;
      let plans = data.plans;
      this.isAnalysUp = data.testFailureAnalysis;
      this.isSelfHealingUp = data.selfHealing;
      plans.forEach((data: any) => {
        let firstRow: any = {};
        for (let i = 0; i < data.executionScripts.length; i++) {
          let child = data.executionScripts[i];
          let row: any = {
            caseName: child.displayName || 'N/A',
            selectedAgent: child.agentId,
            selectedVersion: child.selectedVersion,
            browser: child.browser,
            planId: data?.id,
          }
          if (i == 0) {
            if (data.executionScripts.length > 1) {
              firstRow = { ...row, select: "", planName: data.testPlanName, children: [] };
            } else {
              firstRow = { ...row, select: "", planName: data.testPlanName };
            }

          } else {
            firstRow.children = [...firstRow.children, { ...row }];
          }
        }
        this.dataSource = [...this.dataSource, firstRow]
      });
      this.isSchedulesByIdloaded = true;
    }, (error) => {
      this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_LOAD_FAILURE });
      this.isSchedulesByIdloaded = true;
    });
  }

  editSchedule(schedule: any) {
    const modalRef = this.modalService.open(AddScheduleComponent, {
      centered: false,
      windowClass: "test-plan-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = {
      title: "Add New Test Schedule",
      id: schedule.id
    };
    modalRef.result.then((result) => {
      this.isSchedulesLoaded = false;
      this.getAllSchedules();
    });
  }

  openSaveWithReleasePopup() {
    //TestScheduleRelaseComponent
    const modalRef = this.modalService.open(TestScheduleRelaseComponent, {
      centered: true,
      windowClass: "test-plan-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = {
      title: "Save Test Schedule With Release"
    };
    modalRef.result.then((result) => {
      this.saveSchedule(result);
    });
  }

  save(type?: string) {
    if (type == '+') {
      this.openSaveWithReleasePopup();
    } else {
      this.saveSchedule();
    }
  }

  // Validate cron expression (basic example)
  validateCronExpression(): void {
    const cronPattern = /^(\*|([0-5]?\d)) (\*|([01]?\d|2[0-3])) (\*|([0-3]?\d)) (\*|([01]?\d|1[0-2])) (\*|[0-6])$/;

    if (this.cronExpression && !cronPattern.test(this.cronExpression)) {
      this.errorMessage = 'Invalid cron expression. Please check the format.';
    } else {
      this.errorMessage = null;  // Clear error if valid
    }
  }

  // Function to handle calendar icon click
  openCalendar(): void {
    const modalRef = this.modalService.open(CronExpressionInputComponent, {
      centered: false,
      windowClass: "test-plan-modal",
      backdrop: 'static',
    });
    modalRef.componentInstance.data = {
      title: "Create Cron Expression"
    };
    modalRef.result.then((result) => {
      this.cronExpression = result;
    });
  }

  saveSchedule(releaseId?: string) {
    let activeSchedule = this.activeSchedule;
    let result: any = {
      name: activeSchedule.name,
      testFailureAnalysis: this.isAnalysUp,
      selfHealing: this.isSelfHealingUp,
      cron: this.cronExpression,
      plans: []
    }
    if (releaseId) {
      result.releaseId = releaseId;
    }
    this.activeSchedule.plans.forEach((plan: any) => {
      let curPlan: any = {
        testPlanId: plan.testPlanId,
        testPlanName: plan.testPlanName,
        executionScripts: []
      }
      plan.executionScripts.forEach((script: any) => {
        let curScript: any = {
          sequence: script.sequence,
          id: script.id,
          agentId: script.agentId,
          browser: script.browser
        }
        if (!script.agentId) {
          curScript.agentId = null;
          curScript.agentType = 'CLUSTER';
        }
        curPlan.executionScripts.push(curScript);
      });
      result.plans.push(curPlan);
    });

    this.restService.saveSchedule(this.projectId, this.automationProjectId, result).subscribe((response) => {
      this.activeSchedule = null;
      this.cronExpression = "";
      this.toaster.pop({ type: 'success', text: MessageEnum.SCHEDULE_INITIATE_SUCCESS });
    }, (error) => {
      this.toaster.pop({ type: 'error', text: MessageEnum.SCHEDULE_INITIATE_SUCCESS });
    });
  }
}
